import CryptoJS from 'crypto-js';

export function decrypt(encryptedData, secretKey) {
  const combined = CryptoJS.enc.Hex.parse(encryptedData);//CryptoJS.lib.WordArray.create(encryptedData)
  const iv = CryptoJS.lib.WordArray.create(combined.words.slice(0, 4)); // 提取前 16 字节作为 IV
  const cipherText = CryptoJS.lib.WordArray.create(combined.words.slice(4)); // 剩余的作为密文

  const decrypted = CryptoJS.AES.decrypt({ciphertext: cipherText}, CryptoJS.enc.Utf8.parse(secretKey), {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
  return decryptedString;
}